import clsx from "clsx";
import Image from "next/image";
import bgOnstepCircle from "/public/onstep/bg-onstepCircle.webp";
import serviceLead from "/public/onstep/serviceLead.svg";
import serviceLeadEng from "/public/onstep/serviceLead-eng.svg";
import { LogoOnstep } from "@/components/molecules/logos/LogoOnstep";

const ImageComponent = ({ src, alt, className, priority = false }) => (
  <Image
    src={src}
    alt={alt}
    quality={80}
    fill
    priority={priority}
    className={clsx("object-cover", className)}
  />
);

export const OnstepCover = ({ className }) => {
  return (
    <section
      className={clsx(
        className,
        "relative mx-auto box-border flex h-[556px] w-full max-w-[1536px] items-center justify-center overflow-hidden lg:h-[768px]"
      )}
      aria-label="Onstepサービス概要"
    >
      <div className="relative z-20 flex flex-col items-center justify-center gap-8">
        <h2 className="aspect-[378/132] h-[96px] w-auto md:h-[100px] xl:h-[132px]">
          <ImageComponent
            src={serviceLead}
            alt="ファンマ（ファンマーケティング）を次のステージへ。"
            className="aspect-[378/132] h-[132px]"
            priority
          />
        </h2>
        <div className="prose text-center font-bold text-white">
          <p className="leading-comfort fluid-text-[14px,18px]">
            物販も電子コンテンツも一元管理。
            <br />
            ファンとのコミュニケーション、分析、収益化までを
            <br />
            シームレスに繋ぐ多機能プラットフォーム
          </p>
        </div>
        <LogoOnstep className="h-[124px] w-auto lg:h-[184px]" />
      </div>
      <div className="absolute bottom-[40px] left-1/2 z-10 aspect-[678/202] w-[88%] -translate-x-1/2 sm:bottom-[24px] sm:w-[74%] lg:bottom-[58px] lg:h-[202px] lg:w-auto">
        <ImageComponent
          src={serviceLeadEng}
          alt="ONSTEP - ONLINE SALON Platform"
        />
      </div>
      <div className="absolute bottom-0 left-1/2 z-0 aspect-2/1 h-[556px] w-auto -translate-x-1/2 lg:h-[768px]">
        <ImageComponent
          src={bgOnstepCircle}
          alt="Fan Marketing: The Next Step"
        />
      </div>
    </section>
  );
};
